export const BranchInformationFields = [
  {key: "name", tag: "Name"},
  {key: "address", tag: "Address"},
  {key: "phone", tag: "Phone"},
  {key: "deductions", tag: "Deductions"},
  {key: "companyId", tag: "Company ID"},
  {key: "unique_customer_identification", tag: "Unique customer identification"},
  {key: "unique_serial_number_id", tag: "Unique serial number ID"}
]
